export default __webpack_public_path__ + "static/media/bank3.14391034.png";